import { toast as reactToast } from 'react-toastify';

type ErrorToastArgs = Parameters<typeof reactToast.error>;
type ToastContent = ErrorToastArgs[0];
type ToastOptions = ErrorToastArgs[1];
type ToastKind = 'success' | 'warning' | 'error';
type ToastId = NonNullable<ToastOptions>['toastId'];

const resolveToastId = (kind: ToastKind, content: ToastContent, options?: ToastOptions): ToastId | undefined => {
    if (options?.toastId !== undefined) {
        return options.toastId;
    }

    if (typeof content === 'string' || typeof content === 'number') {
        return `${kind}:${content}`;
    }

    return undefined;
};

const withToastId = (kind: ToastKind, content: ToastContent, options?: ToastOptions): ToastOptions => {
    const toastId = resolveToastId(kind, content, options);
    return toastId === undefined ? options : { ...options, toastId };
};

export const toast = {
    success(content: ToastContent, options?: ToastOptions) {
        return reactToast.success(content, withToastId('success', content, options));
    },
    warning(content: ToastContent, options?: ToastOptions) {
        return reactToast.warning(content, withToastId('warning', content, options));
    },
    error(content: ToastContent, options?: ToastOptions) {
        return reactToast.error(content, withToastId('error', content, { autoClose: false, ...options }));
    },
};
